import { render, staticRenderFns } from "./EditSlug.vue?vue&type=template&id=24b99234&"
import script from "./EditSlug.vue?vue&type=script&lang=ts&"
export * from "./EditSlug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports